<template>
  <div class="container py-5">
    <div class="row">
      <div class="col">
        <div
          class="card border-0 shadow mb-5"
          v-for="bird in birds"
          :key="bird.number"
        >
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-lg-3 mb-3 mb-lg-0">
                <a :href="bird.birdPhotos" target="_blank">
                  <img
                    :src="require('@/assets/img/' + bird.imgSrc)"
                    :alt="`More photos of ${bird.commonName}`"
                    class="img-fluid rounded"
                  />
                </a>
              </div>
              <div class="col-lg-9">
                <h3 class="card-title mb-2 fw-bold">{{ bird.commonName }}</h3>
                <h6 class="card-subtitle mb-3 text-muted">
                  Scientific Name:
                  <span class="fw-bold">{{ bird.scientificName }}</span>
                </h6>
                <div class="mb-4">
                  <span class="alert alert-dark me-3 p-1">
                    Order: <span class="fw-bold">{{ bird.order }}</span></span
                  >
                  <span class="alert alert-dark p-1">
                    Family: <span class="fw-bold">{{ bird.family }}</span></span
                  >
                </div>
                <div class="btn-group mb-4" role="group">
                  <button
                    v-for="(link, i) in bird.songFiles"
                    :key="link"
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    @click="playAudio(link)"
                  >
                    <i class="bi bi-play-fill"></i> Song #{{ i + 1 }}
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger"
                    type="button"
                    @click="stopAudio"
                  >
                    <i class="bi bi-stop-fill"></i>
                  </button>
                </div>
                <p v-if="bird.note" class="card-text">
                  <strong>Notes:</strong> {{ bird.note }}
                </p>

                <div class="mt-4">
                  <p v-if="bird.birdSongSources.length > 0">
                    <strong>Song Sources:</strong>
                  </p>
                  <ul class="list-unstyled">
                    <li v-for="(link, i) in bird.birdSongSources" :key="link">
                      <a :href="link" target="_blank">Recording #{{ i + 1 }}</a>
                    </li>
                  </ul>

                  <p v-if="bird.specimenPhotos.length > 0">
                    <strong>Specimen Photos:</strong>
                  </p>
                  <ul class="list-unstyled">
                    <li v-for="(link, i) in bird.specimenPhotos" :key="link">
                      <a :href="link" target="_blank">Photo #{{ i + 1 }}</a>
                    </li>
                  </ul>

                  <p v-if="bird.featherPhotos.length > 0">
                    <strong>Feather Photos:</strong>
                  </p>
                  <ul class="list-unstyled">
                    <li v-for="(link, i) in bird.featherPhotos" :key="link">
                      <a :href="link" target="_blank">Photo #{{ i + 1 }}</a>
                    </li>
                  </ul>

                  <p v-if="bird.flyingPhoto">
                    <strong>Flying Photo:</strong>
                    <a :href="bird.flyingPhoto" target="_blank">View</a>
                  </p>
                  <p v-if="bird.sketchFabLink">
                    <strong>Sketchfab Link:</strong>
                    <a :href="bird.sketchFabLink" target="_blank">View</a>
                  </p>
                  <p v-if="bird.sketchFabLinkInFlight">
                    <strong>In Flight Sketchfab Link:</strong>
                    <a :href="bird.sketchFabLinkInFlight" target="_blank"
                      >View</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Forest from "@/data/forest.json";
import Wetland from "@/data/wetland.json";
export default {
  name: "ReferenceData",
  data() {
    return {
      audio: null,
      forest: Forest,
      wetland: Wetland,
      birds: []
    };
  },
  created() {
    this.combineJSON();
  },
  methods: {
    combineJSON() {
      this.birds = [...this.forest, ...this.wetland];
    },
    playAudio(path) {
      this.stopAudio(); // Stop any currently playing audio
      this.audio = new Audio(require("@/assets/audio/" + path));
      this.audio.play();
    },
    stopAudio() {
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }
    }
  }
};
</script>
